import { useState } from "react";

const PaymentSection = () => {
  const [copiedLocal, setCopiedLocal] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopiedLocal(true);
    setTimeout(() => setCopiedLocal(false), 1800);
  };

  return (
    <section style={{ padding: "3rem 1rem", backgroundColor: "transparent" }}>
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <h2
          style={{ fontSize: "1.8rem", fontWeight: "600", marginBottom: "6px" }}
        >
          Payment Information
        </h2>
        <p style={{ color: "#6b7280", margin: 0 }}>
          Choose your preferred payment method below
        </p>
      </div>

      {/* Cards Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "16px",
          maxWidth: "780px",
          margin: "0 auto",
        }}
      >
        {/* Local Pakistan Card */}
        <div
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Card Header */}
          <div
            style={{
              padding: "14px 20px 12px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "8px",
                background: "#EAF3DE",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#3B6D11"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="5" width="20" height="14" rx="2" />
                <line x1="2" y1="10" x2="22" y2="10" />
              </svg>
            </div>
            <div>
              <p
                style={{
                  margin: 0,
                  fontSize: "11px",
                  color: "#9ca3af",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                Local Transfer
              </p>
              <p style={{ margin: 0, fontSize: "15px", fontWeight: "500" }}>
                Pakistan Clients
              </p>
            </div>
            <span
              style={{
                marginLeft: "auto",
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
                fontSize: "11px",
                padding: "3px 8px",
                borderRadius: "20px",
                background: "#EAF3DE",
                color: "#3B6D11",
              }}
            >
              <svg width="8" height="8" viewBox="0 0 8 8">
                <circle cx="4" cy="4" r="4" fill="#3B6D11" />
              </svg>
              PKR
            </span>
          </div>

          {/* Card Body */}
          <div style={{ padding: "16px 20px" }}>
            <div style={{ marginBottom: "12px" }}>
              <p
                style={{
                  margin: "0 0 2px",
                  fontSize: "12px",
                  color: "#6b7280",
                }}
              >
                Bank
              </p>
              <p style={{ margin: 0, fontSize: "14px", fontWeight: "500" }}>
                Allied Bank
              </p>
            </div>

            <div style={{ marginBottom: "12px" }}>
              <p
                style={{
                  margin: "0 0 2px",
                  fontSize: "12px",
                  color: "#6b7280",
                }}
              >
                Account Holder
              </p>
              <p style={{ margin: 0, fontSize: "14px", fontWeight: "500" }}>
                Uzair Ahmad Babar
              </p>
            </div>
            <div style={{ marginBottom: "12px" }}>
              <p
                style={{
                  margin: "0 0 2px",
                  fontSize: "12px",
                  color: "#6b7280",
                }}
              >
                Account Number
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  fontWeight: "500",
                  fontFamily: "monospace",
                }}
              >
                05390010130006010017
              </p>
            </div>
            <div style={{ marginBottom: "12px" }}>
              <p
                style={{
                  margin: "0 0 2px",
                  fontSize: "12px",
                  color: "#6b7280",
                }}
              >
                IBAN
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  fontWeight: "500",
                  fontFamily: "monospace",
                }}
              >
                PK24ABPA0010130006010017
              </p>
            </div>
            <button
              onClick={() => copyToClipboard("05390010130006010017")}
              style={{
                width: "100%",
                marginTop: "14px",
                padding: "8px",
                fontSize: "13px",
                cursor: "pointer",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                background: "#f9fafb",
                color: "#6b7280",
                transition: "background 0.15s",
              }}
            >
              {copiedLocal ? "Copied!" : "Copy Account Number"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
export default PaymentSection;
